require('intersection-observer');

let $target = document.querySelectorAll('.js-hide');
let option = {
  threshold: 0.3
};

function handler(changes, observer) {
  changes.forEach(change => {
    if (change.isIntersecting) {
      change.target.classList.add('is-show');
      observer.unobserve(change.target);
    }
  });
}

let observer = new IntersectionObserver(handler, option);
$target.forEach(img => observer.observe(img));
observer.observe($target[0]);
observer.observe($target[1]);